import { useMemo } from 'react'

import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import { DialogTitle, DialogContent } from 'components/dialogs'
import Suspenseful from '../Suspenseful'
import AddClientCampaignForm from './AddClientCampaignForm'
import ProgramGroupsResource from '../../resources/ProgramGroupsResource'
import { useOrbit } from 'providers/OrbitProvider'
import Box from '@mui/material/Box'
import { isNew } from 'lib/DataModel'

export function AddClientCampaignModal({contract, clientCampaign, clientId, onClose, onSave}) {
  const { remote } = useOrbit()
  const programGroupsResource = useMemo(() => new ProgramGroupsResource({ remote, client: { type: 'client', id: clientId } }), [clientId, remote])
  const isNewCampaign = isNew(clientCampaign)

  return (
    <Dialog
      open
      aria-labelledby="modal-title"
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="modal-title" onClose={onClose} sx={{paddingBottom: '4px'}}>
        <Box sx={{ flexGrow: 1 }}>
          {isNewCampaign ? 'Add New' : 'Edit'} Campaign
        </Box>
      </DialogTitle>
      <DialogContent>
        <AddClientCampaignForm
          contract={contract}
          clientCampaign={clientCampaign}
          programGroupsResource={programGroupsResource}
          onSave={onSave}
          isNewCampaign={isNewCampaign}
          clientId={clientId}
        />
      </DialogContent>
    </Dialog>
  )
}

export default function AddClientCampaignModalWrapper({clientCampaign, clientId, contract, onClose, onSave}) {
   return (
     <Suspenseful
       component={AddClientCampaignModal}
       clientCampaign={clientCampaign}
       clientId={clientId}
       contract={contract}
       onClose={onClose}
       onSave={onSave}
       fallback={
         <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%'}}>
           <CircularProgress/>
         </div>
       }
     />
   )
 }
